// src/components/finance/AddPaymentMethodModal.tsx
import React from "react";
import { Modal } from "antd";
import PaymentMethodCardForm from "./PaymentMethodCardForm";
import { attachPaymentMethod, attachPaymentMethodPublic } from "../../api/finance/FinanceApi";

interface AddPaymentMethodModalProps {
	visible: boolean;
	onClose: () => void;
	onSuccess: () => void;
	customerId: string;
	// The anonymous booking flow's capability for `customerId`; present means the public route.
	paymentToken?: string;
}

const AddPaymentMethodModal: React.FC<AddPaymentMethodModalProps> = ({ visible, onClose, onSuccess, customerId, paymentToken }) => {
	const attach = (paymentMethodId: string) =>
		paymentToken ? attachPaymentMethodPublic({ paymentMethodId, customerId }, paymentToken) : attachPaymentMethod({ paymentMethodId, customerId });

	return (
		<Modal title="Add Payment Method" open={visible} onCancel={onClose} footer={null} width={600} destroyOnClose>
			<PaymentMethodCardForm
				onAttach={attach}
				onSuccess={() => {
					onSuccess();
					onClose();
				}}
				onCancel={onClose}
			/>
		</Modal>
	);
};

export default AddPaymentMethodModal;
